import Modal from "bootstrap/js/dist/modal"

class GlobalPopup {
  constructor() {
    const get_modal = document.getElementById('exit-modal')

    if (get_modal) {
      this.onShow(get_modal)
      this.mobilePopup(get_modal)
    }
  }

  closeAllModals = () => {
    const openModals = document.querySelectorAll('.modal.show')
    openModals.forEach(modal => {
      const modalInstance = Modal.getInstance(modal)
      console.log(modalInstance)
      if (modalInstance) {
        modalInstance.hide()
      }
    })
  }

  onShow = (get_modal) => {
    const exitModal = new Modal(get_modal)
    if (!('ontouchstart' in window)) {
      window.addEventListener('mouseout', (e) => {
        const homepage_overlay_letters = Boolean(sessionStorage.getItem("seooneclick-scroll-letters-gone"))
        const is_homepage = document.body.classList.contains('home')
        const is_thanks_page = document.body.classList.contains('page-template-template-thank-you')
        const storedValue = sessionStorage.getItem('one_click_marketing_exit_modal')

        if (is_homepage) {
          if (e.relatedTarget === null && e.clientY <= 0 && !storedValue && homepage_overlay_letters) {
            this.closeAllModals()
            exitModal.show()
            sessionStorage.setItem('one_click_marketing_exit_modal', 'closed')
          } else if (e.relatedTarget === null && e.clientY <= 0 && !storedValue) {
            this.closeAllModals()
            exitModal.show()
            sessionStorage.setItem('one_click_marketing_exit_modal', 'closed')
          }
        } else if(!is_thanks_page) {
          if (e.relatedTarget === null && e.clientY <= 0 && !storedValue) {
            this.closeAllModals()
            exitModal.show()
            sessionStorage.setItem('one_click_marketing_exit_modal', 'closed')
          }
        }
      })
    }
  }

  mobilePopup = (get_modal) => {
    if (window.innerWidth < 1201) {
      let lastScrollTop = 0
      let scrollTimeout

      const exitModal = new Modal(get_modal)

      // Detect quick scroll up for mobile
      if ('ontouchstart' in window) { // This confirms it's a touch device
        window.addEventListener('scroll', () => {
          clearTimeout(scrollTimeout)

          let currentScrollTop = window.scrollY || document.documentElement.scrollTop

          if (currentScrollTop < lastScrollTop) {
            let scrollDifference = lastScrollTop - currentScrollTop

            let storedValue = sessionStorage.getItem('one_click_marketing_exit_modal')
            if (scrollDifference > 50 && !storedValue) {
              exitModal.show()
              sessionStorage.setItem('one_click_marketing_exit_modal', 'closed')
            }
          }

          lastScrollTop = currentScrollTop

          // Reset lastScrollTop after a delay
          scrollTimeout = setTimeout(() => {
            lastScrollTop = currentScrollTop
          }, 100)
        })
      }
    }
  }
}

export default GlobalPopup
